import React, { useState, useEffect, memo } from "react";
import Wrappers from "../shared/Wrappers";
import FilterButtons from "../shared/FilterButtons";

import TableMain from "../shared/TableMain";
import { GetAllCustomer } from "../../../services/admin/customer";
import Loader from "../../shared/loader";
import SharedHeaders from "../shared/SharedHeaders";
import NotFoundIcon from "../../shared/NotFoundIcon";

const CustomerMain = () => {
  const [activeButton, setactiveButton] = useState(0);
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);
  const [SearchInputValue, setSearchInputValue] = useState("");
  const [SelectedAccountType, setSelectedAccountType] = useState("");
  const [SelectedDateCallback, setSelectedDateCallback] = useState("");
  const [CurrentPage, setCurrentPage] = useState(1);

  const ButtonsArray = [
    { title: "All" },
    { title: "Pending" },
    { title: "Approved" },
  ];

  const TableHeadData = [
    { title: "ID", val: "slug" },
    { title: "Name", val: "name" },
    { title: "Email", val: "email" },
    { title: "Phone number", val: "phone_number" },
    { title: "Account Type", val: "user_type" },
    { title: "Status", val: "status" },
    { title: "Company Name", val: "company_name" },
    { title: "Created Date", val: "created_at" },
  ];

  useEffect(() => {
    handleFetchAllCustomer();
  }, [
    activeButton,
    SearchInputValue,
    SelectedDateCallback,
    SelectedAccountType,
    CurrentPage,
  ]);

  const handleFetchAllCustomer = async () => {
    const StatusType = ButtonsArray[activeButton]?.title || "";
    const Search = SearchInputValue || "";
    const Date = SelectedDateCallback || "";
    const AcountType = SelectedAccountType || "";
    const Page = CurrentPage || 1;
    await GetAllCustomer(
      setLoading,
      setAllData,
      StatusType,
      Search,
      Date,
      AcountType,
      Page
    );
  };

  return (
    <Wrappers>
      {loading && <Loader />}
      <SharedHeaders
        Placeholder="Search for Name, Email , Phone Number"
        SearchInputValue={SearchInputValue}
        setSearchInputValue={setSearchInputValue}
        SelectedAccountType={SelectedAccountType}
        setSelectedAccountType={setSelectedAccountType}
        SelectedDateCallback={SelectedDateCallback}
        setSelectedDateCallback={setSelectedDateCallback}
      />
      <FilterButtons
        ButtonsArray={ButtonsArray}
        activeButton={activeButton}
        setactiveButton={setactiveButton}
      />
      {!loading && (
        <>
          {AllData && AllData?.data?.length > 0 ? (
            <>
              <TableMain
                TableHeadData={TableHeadData}
                BodyData={AllData?.data}
                TableType="customers"
                Last_page={AllData?.last_page}
                total_pages={AllData?.total_pages}
                CurrentPage={CurrentPage}
                setCurrentPage={setCurrentPage}
              />
            </>
          ) : (
            !loading && <NotFoundIcon MT="20" IconWidth="10" />
          )}
        </>
      )}
    </Wrappers>
  );
};

export default memo(CustomerMain);
